import { createActionGroup, emptyProps, props } from "@ngrx/store";


export const LoaderActions = createActionGroup({
  source: "Loader Events",
  events: {
    "Start": props<{ message: string }>(),
    "Stop": emptyProps(),
  },
});

